import { render } from "./ParentCard.vue?vue&type=template&id=c6638c00&scoped=true"
import script from "./ParentCard.vue?vue&type=script&lang=js"
export * from "./ParentCard.vue?vue&type=script&lang=js"

import "./ParentCard.vue?vue&type=style&index=0&id=c6638c00&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6638c00"]])

export default __exports__